import { render, staticRenderFns } from "./GovernmentIssuedId.vue?vue&type=template&id=066ba483&scoped=true"
import script from "./GovernmentIssuedId.vue?vue&type=script&lang=js"
export * from "./GovernmentIssuedId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066ba483",
  null
  
)

export default component.exports